<style scoped lang="scss" type="text/scss">
    .account-panel-container {
        width: 100%;

        .info-item {
            width: 100%;
            box-sizing: border-box;
            padding: 0 .5rem;
            margin-bottom: .5rem;
            display: flex;
            align-items: center;

            &:last-of-type {
                margin-bottom: 0;
            }

            .edit-icon {
                font-size: .9rem;
                color: #333;
                opacity: .4;
                transition: all .2s;

                &:hover {
                    cursor: pointer;
                    opacity: 1;
                }
            }

            .content-text {
                flex: 1;
                margin: 0 .8rem;
                font-size: .8rem;
            }

            .tag-item {
                width: 3.5rem;
            }
        }
    }
</style>

<template>
    <div class="account-panel-container">
        <mobile-popup :visible.sync="isMobileEditorShow"></mobile-popup>
        <mobile-popup-no-close :visible.sync="isMobileNoCloseEditorShow"></mobile-popup-no-close>
        <email-popup :visible.sync="isEmailEditorShow"></email-popup>
        <email-popup-no-close :visible.sync="isEmailNoCloseEditorShow"></email-popup-no-close>
        <password-popup :visible.sync="isPasswordEditorShow"></password-popup>

        <div class="info-item username-password-info">
            <plain-tag class="tag-item" text-color="#EEE" bg-color="#666" border-color="#666">
                用户名
            </plain-tag>
            <span class="content-text editable global-text-ellipsis">
                {{ username }}
            </span>
            <i @click="editPassword" class="icon edit-icon" title="修改密码">&#xe6d5;</i>
        </div>
        <div class="info-item wechat-info" v-if="false">
            <plain-tag class="tag-item" text-color="#EEE" bg-color="#666" border-color="#666">
                微信
            </plain-tag>
            <span class="content-text editable global-text-ellipsis">
                {{ wechat || '暂未绑定' }}
            </span>
            <i class="icon edit-icon" title="点击绑定">&#xe66d;</i>
            <!--<i class="icon edit-icon" title="点击解绑">&#xe6ef;</i>-->
        </div>
        <div class="info-item phone-info">
            <plain-tag class="tag-item" text-color="#666" bg-color="#CEE5FF" border-color="#CEE5FF">
                手机
            </plain-tag>
            <span class="content-text editable global-text-ellipsis">
                {{ mobile || '暂未绑定' }}
            </span>
            <i @click="editMobile" class="icon edit-icon" title="点击修改">&#xe65c;</i>
        </div>
        <div class="info-item email-info">
            <plain-tag class="tag-item" text-color="#666" bg-color="#CEE5FF" border-color="#CEE5FF">
                邮箱
            </plain-tag>
            <span class="content-text editable global-text-ellipsis">
                {{ email || '暂未绑定' }}
            </span>
            <i @click="editEmail" class="icon edit-icon" title="点击修改">&#xe65c;</i>
        </div>
    </div>
</template>

<script>
    import PlainTag from '../../../../components/plain-tag/index';
    import MobilePopup from './popup/mobile';
    import MobilePopupNoClose from './popup/mobile-no-close';
    import EmailPopup from './popup/email';
    import EmailPopupNoClose from './popup/email-no-close';
    import PasswordPopup from './popup/password';
    import _ from 'lodash';

    export default {
        name: '',
        components: {
            PlainTag,
            MobilePopup,
            MobilePopupNoClose,
            EmailPopup,
            EmailPopupNoClose,
            PasswordPopup,
        },
        mounted() {
            // console.log(_.get(this.selfInfo, 'mobile'))
            if (_.get(this.selfInfo, 'mobile') == null || _.get(this.selfInfo, 'mobile') === "") {
                this.isMobileNoCloseEditorShow = true;
            }
            // 暂时关闭邮箱必须绑定的逻辑
            // if (_.get(this.selfInfo, 'email') == null || _.get(this.selfInfo, 'email') === "") {
            //     this.isEmailNoCloseEditorShow = true;
            // }
        },
        data () {
            return {
                isMobileEditorShow: false,
                isEmailEditorShow: false,
                isMobileNoCloseEditorShow: false,
                isEmailNoCloseEditorShow: false,
                isPasswordEditorShow: false
            };
        },
        computed: {
            selfInfo () {
                return this.$store.state.user.selfInfo;
            },
            username () {
                return this.$store.getters['user/username'];
            },
            wechat () {
                return _.get(this.selfInfo, 'wechat');
            },
            mobile () {
                return _.get(this.selfInfo, 'mobile');
            },
            email () {
                return _.get(this.selfInfo, 'email');
            }
        },
        methods: {
            editMobile () {
                this.isMobileEditorShow = true;
            },
            editEmail () {
                this.isEmailEditorShow = true;
            },
            editPassword () {
                this.isPasswordEditorShow = true;
            }
        }
    };
</script>
